import alertManagement from "./alertManagement/en";
import assetManagement from "./assetManagement/en";
import authUser from "./authUser/en";
import configurator from "./configurator/en";
import development from "./development/en";
import deviceManagement from "./deviceManagement/en";
import feedback from "./feedback/en";
import fleetInventory from "./fleetInventory/en";
import fleetManagement from "./fleetManagement/en";
import groups from "./groups/en";
import home from "./home/en";
import manufacturer from "./manufacturer/en";
import map from "./map/en";
import noAccessMessage from "./noAccessMessage/en";
import settings from "./settings/en";
import softwareManagement from "./softwareManagement/en";
import userManagement from "./userManagement/en";
import billingAddress from "./billingAddress/en";
import projects from "./projects/en";
import contact from "./contact/en";

export default {
  projects,
  alertManagement,
  assetManagement,
  authUser,
  configurator,
  development,
  deviceManagement,
  feedback,
  fleetInventory,
  fleetManagement,
  groups,
  home,
  manufacturer,
  map,
  noAccessMessage,
  settings,
  softwareManagement,
  userManagement,
  billingAddress,
  contact,
};
